export { ConsentedScopes } from './consented-scopes'
